import React, { Component } from 'react'

class Test1 extends Component {
    render() {
        return (
            <div>
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                In Test component
            </div>
        )
    }
}

export default Test1
